export const BANNER_2_CONSTANTS = {
  // Metadata titles for better identification in admin panel
  METADATA_TITLES: {
    metadata: "Banner Images",
    metadata_1: "Feature Items",
    metadata_2: "Accreditation",
    metadata_3: "Learner Avatars",
  },

  // Default row for banner images (Metadata 1)
  DEFAULT_ROW: {
    id: "1",
    image: "",
    enable_video: false,
    video_link: "",
    priority: 1,
    status: true,
    border_color: "#00d4eb",
  },

  // Default row for items (Metadata 2)
  DEFAULT_ROW_1: {
    id: "1",
    icon: "",
    alt_icon: "Feature icon",
    description: "Feature description",
    description_color: "#FFFFFF",
    priority: 1,
    status: true,
  },

  // Default row for accreditation (Metadata 3)
  DEFAULT_ROW_2: {
    id: "1",
    image: "",
    alt_image: "Accreditation",
    priority: 1,
    status: true,
  },

  // Default row for learners items (Metadata 4)
  DEFAULT_ROW_3: {
    id: "1",
    image: "",
    priority: 1,
    status: true,
  },

  BANNER_FIELDS_CONFIG: [
    {
      fieldName: "slide_frequency",
      label: "Slide Frequency",
      value: 5000,
      valueType: "number",
      filedType: "INPUT",
      placeholder: "Enter Slide Frequency (ms)",
      required: true,
      defaultValue: 5000,
    },
    {
      fieldName: "hero_video_url",
      label: "Background Video",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Video (plays in place of the image, autoplay & loop)",
      required: false,
      defaultValue: "",
      accept: "video/*",
      description:
        "Optional. When uploaded, this video autoplays (muted, looping, no controls) in place of the banner image.",
    },
    {
      fieldName: "title_1",
      label: "Title 1",
      value: "Online course in",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Title 1",
      // required: true,
      defaultValue: "Online course in",
    },
    {
      fieldName: "title_1_color",
      label: "Title 1 Color",
      value: "#FFFFFFCC",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Title 1 Color (e.g., #FFFFFF)",
      defaultValue: "#FFFFFFCC",
    },
    {
      fieldName: "title_2",
      label: "Title 2",
      value: "Financial Planning and Applied Finance",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Title 2",
      // required: true,
      defaultValue: "Financial Planning and Applied Finance",
    },
    {
      fieldName: "title_2_gradient_start_color",
      label: "Title 2 Gradient Start Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#FFFFFF",
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "title_2_gradient_end_color",
      label: "Title 2 Gradient End Color",
      value: "#00D4EB",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#00D4EB",
      defaultValue: "#00D4EB",
    },
    {
      fieldName: "title_2_gradient_angle",
      label: "Title 2 Gradient Angle",
      value: "90deg",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter gradient angle (e.g., 90deg, 180deg)",
      defaultValue: "90deg",
    },
    {
      fieldName: "subtitle",
      label: "Subtitle",
      value: "with CFP® Global Certification program",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Subtitle",
      required: false,
      defaultValue: "with CFP® Global Certification program",
    },
    {
      fieldName: "subtitle_color",
      label: "Subtitle Color",
      value: "#FFFFFFCC",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Subtitle Color (e.g., #FFFFFF)",
      defaultValue: "#FFFFFFCC",
    },
    {
      fieldName: "horizontal_stripe_color",
      label: "Horizontal Stripe Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Horizontal Stripe Color (e.g., #FFFFFF)",
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "font_family_variant",
      label: "Font Family",
      value: "variant_2",
      valueType: "string",
      filedType: "SELECT",
      placeholder: "Select font family",
      required: false,
      defaultValue: "variant_2",
      className: "h-9 py-1.5 text-sm",
      iconClassName: "!size-4",
      options: [
        { label: "Variant 1", value: "variant_1" },
        { label: "Variant 2", value: "variant_2" },
      ],
    },
    {
      fieldName: "backvariant",
      label: "Background Variant",
      value: "variant_1",
      valueType: "string",
      filedType: "SELECT",
      placeholder: "Select Background Variant",
      required: true,
      defaultValue: "variant_1",
      className: "h-9 py-1.5 text-sm",
      iconClassName: "!size-4",
      options: [
        { label: "Variant 1", value: "variant_1" },
        { label: "Variant 2", value: "variant_2" },
        { label: "Variant 3", value: "variant_3" },
      ],
    },
    {
      fieldName: "gradient_color_1",
      label: "Gradient Color 1",
      value: "#00D4EB54",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Gradient Color 1",
      required: false,
      defaultValue: "#00D4EB54",
    },
    {
      fieldName: "gradient_color_2",
      label: "Gradient Color 2",
      value: "#000000A8",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Gradient Color 2",
      required: false,
      defaultValue: "#000000A8",
    },
    {
      fieldName: "gradient_color_3",
      label: "Gradient Color 3",
      value: "#000000A8",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Gradient Color 3",
      required: false,
      defaultValue: "#000000A8",
    },
    {
      fieldName: "gradient_color_4",
      label: "Gradient Color 4",
      value: "#5345C3",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Gradient Color 4",
      required: false,
      defaultValue: "#5345C3",
    },
    {
      fieldName: "background_color",
      label: "Background Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Background Color",
      required: false,
      defaultValue: "#000000",
    },
    // ── Right-hand slot ──────────────────────────────────────────────────
    // Desktop (≥1080) shows EITHER the media (images / video / carousel) OR the
    // university's configured inline lead form — never both. Below 1080 the
    // media always wins and this toggle has no effect, so mobile is unchanged.
    // Turning it on also hides the learners/rating strip on desktop, since that
    // strip belongs to the media option; on mobile it keeps rendering.
    {
      fieldName: "enable_lead_form",
      label:
        "Show lead form instead of media (desktop only — uses the university's configured form)",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Show lead form instead of media",
      defaultValue: false,
    },
    {
      fieldName: "show_learners",
      label: "Show Learners",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Show Learners",
      defaultValue: true,
    },
    {
      fieldName: "learners_description",
      label: "Learners Description",
      value: "<p>Join <strong>10k+</strong> alumni</p>",
      valueType: "string",
      filedType: "RICH_TEXT_EDITOR",
      placeholder: "Enter Learners Description",
      required: false,
      defaultValue: "<p>Join <strong>10k+</strong> alumni</p>",
    },
    {
      fieldName: "status",
      label: "Banner Status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable Banner",
      defaultValue: true,
    },
    {
      fieldName: "carousel_color",
      label: "Carousel Color",
      value: "#c8faff",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Carousel Color (e.g., #c8faff)",
      defaultValue: "#c8faff",
    },
    {
      fieldName: "accreditation_scroll_duration",
      label: "Accreditation Scroll Duration (milliseconds)",
      value: 20000,
      valueType: "number",
      filedType: "INPUT",
      placeholder: "Enter scroll duration in milliseconds (e.g., 20000)",
      required: false,
      defaultValue: 20000,
    },
    {
      fieldName: "show_rating",
      label: "Show Rating",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Show Rating",
      defaultValue: true,
    },
    {
      fieldName: "rating_number",
      label: "Rating Number",
      value: "4/5",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Rating Number (e.g., 4/5)",
      required: false,
      defaultValue: "4/5",
    },
    {
      fieldName: "rating_text",
      label: "Rating Text",
      value: "(7812 ratings)",
      valueType: "string",
      filedType: "RICH_TEXT_EDITOR",
      placeholder: "Enter Rating Text",
      required: false,
      defaultValue: "(7812 ratings)",
    },
    {
      fieldName: "rating_color",
      label: "Rating Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Rating Color",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "rating_number_color",
      label: "Rating Number Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Rating Number Color",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "download_brochure_text",
      label: "Download Brochure Text",
      value: "Download Brochure",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Download Brochure Text",
      defaultValue: "Download Brochure",
    },
    {
      fieldName: "button_color",
      label: "Button Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Button Color (e.g., #FFFFFF)",
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "icon",
      label: "Icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Icon",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "alt_icon",
      label: "Alt Icon",
      value: "Download icon",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Alt Icon Text",
      required: false,
      defaultValue: "Download icon",
    },
    {
      fieldName: "icon_color",
      label: "Icon Color",
      value: "#222222",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Icon Color (e.g., #222222)",
      defaultValue: "#222222",
    },
    {
      fieldName: "apply_now_text",
      label: "Apply Now Text",
      value: "Apply Now",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Apply Now Text",
      defaultValue: "Apply Now",
    },
    {
      fieldName: "apply_now_color",
      label: "Apply Now Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Apply Now Text Color (e.g., #FFFFFF)",
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "apply_now_border_color",
      label: "Apply Now Border Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Apply Now Border Color (e.g., #BE2330)",
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "enable_animation",
      label: "Enable Animation",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable animation",
      required: false,
      defaultValue: false,
    },
  ],

  // Metadata 1: Banner Images (Max 3)
  METADATA_FIELDS: [
    {
      header: "Image",
      fieldName: "image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Banner Image",
      // required: true,
      defaultValue: "",
    },
    {
      header: "Enable Video",
      fieldName: "enable_video",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable Video on this image",
      defaultValue: false,
    },
    {
      header: "Video Link",
      fieldName: "video_link",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter YouTube Video URL",
      required: false,
      defaultValue: "",
    },
    {
      header: "Priority",
      fieldName: "priority",
      value: 1,
      valueType: "number",
      filedType: "INPUT",
      placeholder: "Enter Priority",
      // required: true,
      defaultValue: 1,
    },
    {
      header: "Status",
      fieldName: "status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable",
      defaultValue: true,
    },
    {
      header: "Border Color",
      fieldName: "border_color",
      value: "#00d4eb",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Border Color (e.g., #00d4eb)",
      defaultValue: "#00d4eb",
    },
  ],

  // Metadata 2: Items
  METADATA_FIELDS_1: [
    {
      header: "Icon",
      fieldName: "icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Icon",
      // required: true,
      defaultValue: "",
    },
    {
      header: "Alt Icon",
      fieldName: "alt_icon",
      value: "Feature icon",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Alt Icon Text",
      required: false,
      defaultValue: "Feature icon",
    },
    {
      header: "Description",
      fieldName: "description",
      value: "Feature description",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Description",
      // required: true,
      defaultValue: "Feature description",
    },
    {
      header: "Description Color",
      fieldName: "description_color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Description Color (e.g., #FFFFFF)",
      defaultValue: "#FFFFFF",
    },
    {
      header: "Priority",
      fieldName: "priority",
      value: 1,
      valueType: "number",
      filedType: "INPUT",
      placeholder: "Enter Priority",
      // required: true,
      defaultValue: 1,
    },
    {
      header: "Status",
      fieldName: "status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable",
      defaultValue: true,
    },
  ],

  // Metadata 3: Accreditation (single image per item — icon + text baked in)
  METADATA_FIELDS_2: [
    {
      header: "Image",
      fieldName: "image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Accreditation Image",
      // required: true,
      defaultValue: "",
    },
    {
      header: "Alt Image",
      fieldName: "alt_image",
      value: "Accreditation",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Alt Image Text",
      required: false,
      defaultValue: "Accreditation",
    },
    {
      header: "Priority",
      fieldName: "priority",
      value: 1,
      valueType: "number",
      filedType: "INPUT",
      placeholder: "Enter Priority",
      // required: true,
      defaultValue: 1,
    },
    {
      header: "Status",
      fieldName: "status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable",
      defaultValue: true,
    },
  ],

  // Metadata 4: Learners Items
  METADATA_FIELDS_3: [
    {
      header: "Image",
      fieldName: "image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Learner Image",
      // required: true,
      defaultValue: "",
    },
    {
      header: "Priority",
      fieldName: "priority",
      value: 1,
      valueType: "number",
      filedType: "INPUT",
      placeholder: "Enter Priority",
      // required: true,
      defaultValue: 1,
    },
    {
      header: "Status",
      fieldName: "status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable",
      defaultValue: true,
    },
  ],
};
